
import { REGISTER_USER, REGISTER_USER_FAILED, REGISTER_USER_SUCCESSFUL, UPDATE_USER } from "./actionTypes";
export const registerUser = (user)  => {
  return {
    type: REGISTER_USER,
    payload: user,
  };
};

export const registerUserSuccessful = (user) => {
  return {
    type: REGISTER_USER_SUCCESSFUL,
    payload: user,
  };
};

export const registerUserFailed = (user) => {
  return {
    type: REGISTER_USER_FAILED,
    payload: user,
  };
};


export const registrationError = error => {
  return {
    type: REGISTER_USER_FAILED,
    payload: error,
  }
}

export const updateUser = (user) => {
  return {
    type: UPDATE_USER,
    payload: user,
  };
};
